export default __webpack_public_path__ + "static/media/circle.9e0d1a41.svg";